import React from 'react';
import {Review} from '../../../model/common/Review';
import StarRating from './StarRating';
import {motion} from 'framer-motion';

interface ReviewCardProps {
    review: Review;
}

const ReviewCard: React.FC<ReviewCardProps> = ({review}) => {
    // Format the date
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('pl-PL', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(date);
    };

    return (
        <motion.div
            className="card h-100 bg-light-dark rounded shadow"
            whileHover={{scale: 1.02}}
            transition={{duration: 0.3}}
        >
            <div className="card-body p-6">
                <div className="d-flex justify-content-between align-items-start mb-4">
                    <div>
                        <h5 className="mb-1 text-white fw-bold">{review.name}</h5>
                        <p className="mb-0 text-secondary-light small">{review.details}</p>
                    </div>
                    <div className="text-end" style={{ minWidth: '120px' }}>
                        <StarRating rating={review.rating}/>
                        <p className="mb-0 text-secondary-light small mt-1 text-nowrap">{formatDate(review.addedAt)}</p>
                    </div>
                </div>
                <div className="review-content text-secondary-light">
                    <div dangerouslySetInnerHTML={{__html: review.review}}/>
                </div>
            </div>
            {/*<div className="card-footer bg-secondary-dark p-4 border-top-0">*/}
            <div className="card-footer p-4"
                 style={{
                     background: 'rgba(36, 46, 60, 0.85)',
                     borderTop: '1px solid rgba(255, 255, 255, 0.08)',
                     boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.1)'
                 }}>
                <div className="d-flex align-items-center">
                    <div className="quote-icon text-success me-2">
                        <span className="fs-6">"</span>
                    </div>
                    <div className="text-secondary-light small">
                        {review.courseInfo || "Kursant Produkacja"}
                    </div>
                </div>
            </div>
        </motion.div>
    );
};

export default ReviewCard;
